import { RouteRequirements } from './Router.types';

export const restrictedRoutes: Record<string, RouteRequirements> = {
  '/dashboard': {
    permissions: ['Leads:Get'],
  },
  '/inbox': {
    permissions: ['Messages:Get'],
  },
  '/pipeline': {
    permissions: ['Leads:Get'],
  },
  '/calendar': {
    permissions: ['Properties:Get'],
  },
  '/reports': {
    permissions: ['Reports:Get', 'CustomReports:Get', 'Analytics:Get'],
  },
  '/properties': {
    permissions: ['Properties:Get'],
  },
  '/publishing': {
    permissions: ['AgencySettings:Get'],
  },
  '/third-party-agency': {
    permissions: ['AgencySettings:Get'],
  },
  '/calendar-import': {
    permissions: ['AgencySettings:Get'],
  },
  '/integrations': {
    permissions: ['AgencySettings:Get'],
  },
  '/integrations-migrated': {
    permissions: ['AgencySettings:Get'],
  },
  '/channels': {
    permissions: ['AgencySettings:Get'],
  },
  '/channels-migrated': {
    permissions: ['AgencySettings:Get'],
  },
  '/my-templates': {
    permissions: ['AgencySettings:Get'],
  },
  '/automations-migrated': {
    permissions: ['AgencySettings:Get'],
  },
  '/owners': {
    permissions: ['AgencySettings:Get'],
  },
  '/promo-codes': {
    permissions: ['AgencySettings:Get'],
  },
  '/agency-settings': {
    permissions: ['AgencySettings:Get'],
  },
  '/turnover-management': {
    permissions: ['AgencySettings:Get'],
  },
  '/refer': {
    permissions: ['AgencySettings:Get'],
  },
  '/analytics': {
    permissions: ['Analytics:Get'],
  },
  '/screen-and-protect': {
    permissions: ['AgencySettings:Get'],
  },
};

export const onlyShowContentRoutes = [
  '/oauth/authorize',
  '/onboarding/invite-peers',
];
